import NavBar from './NavBar';
import './NavBar.less'

export default NavBar
